import React, { useState } from 'react';
import { CalendarIcon, ClockIcon, UserIcon, PlusIcon, CheckCircleIcon, XCircleIcon, AlertCircleIcon, ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
export const ScreeningScheduler = () => {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showNewScreeningModal, setShowNewScreeningModal] = useState(false);
  const daysInMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0).getDate();
  const firstDayOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1).getDay();
  const prevMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  };
  const nextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  };
  const isToday = date => {
    const today = new Date();
    return date.getDate() === today.getDate() && date.getMonth() === today.getMonth() && date.getFullYear() === today.getFullYear();
  };
  const isSelected = date => {
    return date.getDate() === selectedDate.getDate() && date.getMonth() === selectedDate.getMonth() && date.getFullYear() === selectedDate.getFullYear();
  };
  const hasScreenings = date => {
    // Mock data - in real app, would check against actual screenings
    const day = date.getDate();
    return [2, 5, 10, 15, 20, 25].includes(day);
  };
  const renderCalendar = () => {
    const days = [];
    const monthStart = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
    // Add empty cells for days before the first day of the month
    for (let i = 0; i < firstDayOfMonth; i++) {
      days.push(<div key={`empty-${i}`} className="h-12 border-t border-l border-gray-200" data-id="element-1114"></div>);
    }
    // Add cells for each day of the month
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), day);
      const hasEvents = hasScreenings(date);
      const _isToday = isToday(date);
      const _isSelected = isSelected(date);
      days.push(<div key={day} onClick={() => setSelectedDate(date)} className={`h-32 border-t border-l border-gray-200 p-2 cursor-pointer transition-colors ${_isSelected ? 'bg-indigo-50' : _isToday ? 'bg-blue-50' : ''} hover:bg-gray-50`} data-id="element-1115">
          <div className="flex justify-between" data-id="element-1116">
            <span className={`text-sm font-medium ${_isToday ? 'text-blue-600' : ''}`} data-id="element-1117">
              {day}
            </span>
            {hasEvents && <span className="w-2 h-2 rounded-full bg-indigo-500" data-id="element-1118"></span>}
          </div>
          {day === 15 && <div className="mt-2 p-1 bg-indigo-100 text-indigo-800 text-xs rounded" data-id="element-1119">
              3 Screenings
            </div>}
          {day === 20 && <div className="mt-2 p-1 bg-green-100 text-green-800 text-xs rounded" data-id="element-1120">
              2 Screenings
            </div>}
        </div>);
    }
    return days;
  };
  const screenings = [{
    id: 1,
    candidate: 'James Wilson',
    position: 'Frontend Developer',
    time: '10:00 AM',
    duration: '30 min',
    status: 'Confirmed'
  }, {
    id: 2,
    candidate: 'Sophia Garcia',
    position: 'Data Scientist',
    time: '11:30 AM',
    duration: '30 min',
    status: 'Confirmed'
  }, {
    id: 3,
    candidate: 'Robert Taylor',
    position: 'DevOps Engineer',
    time: '2:00 PM',
    duration: '30 min',
    status: 'Pending'
  }];
  return <div data-id="element-1121">
      <div className="mb-6" data-id="element-1122">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1123">Screening Schedule</h1>
        <p className="text-gray-600" data-id="element-1124">
          Manage and schedule candidate screenings.
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1125">
        <div className="lg:col-span-2" data-id="element-1126">
          <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-1127">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-1128">
              <div className="flex items-center" data-id="element-1129">
                <button onClick={prevMonth} className="p-1 rounded-full hover:bg-gray-100" data-id="element-1130">
                  <ChevronLeftIcon size={20} data-id="element-1131" />
                </button>
                <h2 className="text-lg font-medium mx-4" data-id="element-1132">
                  {currentMonth.toLocaleString('default', {
                  month: 'long',
                  year: 'numeric'
                })}
                </h2>
                <button onClick={nextMonth} className="p-1 rounded-full hover:bg-gray-100" data-id="element-1133">
                  <ChevronRightIcon size={20} data-id="element-1134" />
                </button>
              </div>
              <button onClick={() => setShowNewScreeningModal(true)} className="inline-flex items-center px-3 py-1.5 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-1135">
                <PlusIcon size={16} className="mr-1" data-id="element-1136" />
                New Screening
              </button>
            </div>
            <div className="grid grid-cols-7 text-center text-xs font-medium text-gray-500 border-b border-gray-200" data-id="element-1137">
              {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map((day, index) => <div key={index} className="py-2" data-id="element-1138">
                    {day}
                  </div>)}
            </div>
            <div className="grid grid-cols-7" data-id="element-1139">{renderCalendar()}</div>
          </div>
        </div>
        <div data-id="element-1140">
          <div className="bg-white rounded-lg shadow overflow-hidden" data-id="element-1141">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-1142">
              <h3 className="font-medium" data-id="element-1143">
                {selectedDate.toLocaleDateString('default', {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
              })}
              </h3>
              <div className="text-sm text-gray-500" data-id="element-1144">
                {screenings.length} screenings
              </div>
            </div>
            <div className="p-4 space-y-4" data-id="element-1145">
              {screenings.length > 0 ? screenings.map(screening => <div key={screening.id} className="border border-gray-200 rounded-lg p-3" data-id="element-1146">
                    <div className="flex justify-between items-start mb-2" data-id="element-1147">
                      <div data-id="element-1148">
                        <h4 className="font-medium" data-id="element-1149">{screening.candidate}</h4>
                        <p className="text-sm text-gray-500" data-id="element-1150">
                          {screening.position}
                        </p>
                      </div>
                      {screening.status === 'Confirmed' ? <CheckCircleIcon size={16} className="text-green-500" data-id="element-1151" /> : <AlertCircleIcon size={16} className="text-yellow-500" data-id="element-1152" />}
                    </div>
                    <div className="flex items-center text-sm text-gray-600 mb-3" data-id="element-1153">
                      <ClockIcon size={14} className="mr-1" data-id="element-1154" />
                      <span data-id="element-1155">
                        {screening.time} ({screening.duration})
                      </span>
                    </div>
                    <div className="flex space-x-2" data-id="element-1156">
                      <button className="flex-1 bg-indigo-600 text-white px-3 py-1 rounded text-sm" data-id="element-1157">
                        View Details
                      </button>
                      <button className="flex-1 border border-gray-300 text-gray-600 px-3 py-1 rounded text-sm" data-id="element-1158">
                        {screening.status === 'Confirmed' ? 'Reschedule' : 'Confirm'}
                      </button>
                    </div>
                  </div>) : <div className="text-center py-8" data-id="element-1159">
                  <CalendarIcon size={40} className="mx-auto text-gray-400 mb-3" data-id="element-1160" />
                  <p className="text-gray-500" data-id="element-1161">
                    No screenings scheduled for this day
                  </p>
                  <button onClick={() => setShowNewScreeningModal(true)} className="mt-3 inline-flex items-center px-3 py-1.5 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-1162">
                    <PlusIcon size={16} className="mr-1" data-id="element-1163" />
                    Schedule Screening
                  </button>
                </div>}
            </div>
          </div>
          <div className="bg-white rounded-lg shadow overflow-hidden mt-6" data-id="element-1164">
            <div className="p-4 border-b border-gray-200" data-id="element-1165">
              <h3 className="font-medium" data-id="element-1166">Upcoming Screenings</h3>
            </div>
            <div className="p-4" data-id="element-1167">
              <div className="space-y-4" data-id="element-1168">
                <div data-id="element-1169">
                  <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-1170">
                    Tomorrow
                  </h4>
                  <div className="border border-gray-200 rounded-lg p-3" data-id="element-1171">
                    <div className="flex justify-between items-start" data-id="element-1172">
                      <div data-id="element-1173">
                        <h4 className="font-medium" data-id="element-1174">Alex Johnson</h4>
                        <p className="text-sm text-gray-500" data-id="element-1175">UX Designer</p>
                      </div>
                      <CheckCircleIcon size={16} className="text-green-500" data-id="element-1176" />
                    </div>
                    <div className="flex items-center text-sm text-gray-600 mt-1" data-id="element-1177">
                      <ClockIcon size={14} className="mr-1" data-id="element-1178" />
                      <span data-id="element-1179">9:30 AM (30 min)</span>
                    </div>
                  </div>
                </div>
                <div data-id="element-1180">
                  <h4 className="text-sm font-medium text-gray-500 mb-2" data-id="element-1181">
                    This Week
                  </h4>
                  <div className="space-y-2" data-id="element-1182">
                    <div className="border border-gray-200 rounded-lg p-3" data-id="element-1183">
                      <div className="flex justify-between items-start" data-id="element-1184">
                        <div data-id="element-1185">
                          <h4 className="font-medium" data-id="element-1186">Maria Sanchez</h4>
                          <p className="text-sm text-gray-500" data-id="element-1187">
                            Product Manager
                          </p>
                        </div>
                        <CheckCircleIcon size={16} className="text-green-500" data-id="element-1188" />
                      </div>
                      <div className="flex items-center text-sm text-gray-600 mt-1" data-id="element-1189">
                        <CalendarIcon size={14} className="mr-1" data-id="element-1190" />
                        <span data-id="element-1191">Wed, Jun 22 • 11:00 AM</span>
                      </div>
                    </div>
                    <div className="border border-gray-200 rounded-lg p-3" data-id="element-1192">
                      <div className="flex justify-between items-start" data-id="element-1193">
                        <div data-id="element-1194">
                          <h4 className="font-medium" data-id="element-1195">David Park</h4>
                          <p className="text-sm text-gray-500" data-id="element-1196">
                            Backend Developer
                          </p>
                        </div>
                        <AlertCircleIcon size={16} className="text-yellow-500" data-id="element-1197" />
                      </div>
                      <div className="flex items-center text-sm text-gray-600 mt-1" data-id="element-1198">
                        <CalendarIcon size={14} className="mr-1" data-id="element-1199" />
                        <span data-id="element-1200">Fri, Jun 24 • 2:30 PM</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showNewScreeningModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-1201">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-md" data-id="element-1202">
            <div className="p-4 border-b border-gray-200 flex justify-between items-center" data-id="element-1203">
              <h3 className="font-medium" data-id="element-1204">Schedule New Screening</h3>
              <button onClick={() => setShowNewScreeningModal(false)} data-id="element-1205">
                <XCircleIcon size={20} className="text-gray-500" data-id="element-1206" />
              </button>
            </div>
            <div className="p-4" data-id="element-1207">
              <div className="space-y-4" data-id="element-1208">
                <div data-id="element-1209">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1210">
                    Candidate
                  </label>
                  <div className="relative" data-id="element-1211">
                    <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-1212">
                      <UserIcon size={16} className="text-gray-400" data-id="element-1213" />
                    </div>
                    <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" placeholder="Select or enter candidate name" data-id="element-1214" />
                  </div>
                </div>
                <div data-id="element-1215">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1216">
                    Position
                  </label>
                  <select className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" data-id="element-1217">
                    <option data-id="element-1218">Frontend Developer</option>
                    <option data-id="element-1219">Backend Developer</option>
                    <option data-id="element-1220">Full Stack Developer</option>
                    <option data-id="element-1221">UX Designer</option>
                    <option data-id="element-1222">Product Manager</option>
                    <option data-id="element-1223">Data Scientist</option>
                  </select>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-1224">
                  <div data-id="element-1225">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1226">
                      Date
                    </label>
                    <div className="relative" data-id="element-1227">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-1228">
                        <CalendarIcon size={16} className="text-gray-400" data-id="element-1229" />
                      </div>
                      <input type="date" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" data-id="element-1230" />
                    </div>
                  </div>
                  <div data-id="element-1231">
                    <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1232">
                      Time
                    </label>
                    <div className="relative" data-id="element-1233">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-1234">
                        <ClockIcon size={16} className="text-gray-400" data-id="element-1235" />
                      </div>
                      <input type="time" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" data-id="element-1236" />
                    </div>
                  </div>
                </div>
                <div data-id="element-1237">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1238">
                    Duration
                  </label>
                  <select className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" data-id="element-1239">
                    <option data-id="element-1240">15 minutes</option>
                    <option data-id="element-1241">30 minutes</option>
                    <option data-id="element-1242">45 minutes</option>
                    <option data-id="element-1243">60 minutes</option>
                  </select>
                </div>
                <div data-id="element-1244">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1245">
                    Notes
                  </label>
                  <textarea rows={3} className="block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" placeholder="Add any additional information..." data-id="element-1246"></textarea>
                </div>
              </div>
              <div className="mt-6 flex justify-end space-x-3" data-id="element-1247">
                <button onClick={() => setShowNewScreeningModal(false)} className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50" data-id="element-1248">
                  Cancel
                </button>
                <button onClick={() => setShowNewScreeningModal(false)} className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-1249">
                  Schedule
                </button>
              </div>
            </div>
          </div>
        </div>}
    </div>;
};